import React, {Component} from 'react'
import CartilhaProcom from '../../../assets/documents/cartilha-procon.pdf'
import PerguntasList from './PerguntasList'

export default class Perguntas extends Component {
  constructor() {
    super();
    this.state = {'perguntas': []};
  }

  componentDidMount() {
    this.setState({'perguntas': PerguntasList.getList()});
  }

  render() {
    return (
      <div>
        <section className="pt-4 pb-5">

          <div className="meiaentrada-title mb-5">
            <div className="container">
              <div className="meiaentrada-title-border-hide">
                <h1>Perguntas frequentes</h1>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="row">
              <div className="col">

                <div>
                  <ul className='pl-3'>
                    <li>
                      Faça o download da cartilha <a href={CartilhaProcom} target='blank'><b><u>O direito
                      estudantil à meia-entrada</u></b></a> em parceria com o
                      PROCON.
                    </li>
                  </ul>
                </div>


                <div id="accordion" role="tablist" className='faq-questions'>
                  {
                    this.state.perguntas.map((pergunta) => {
                      return (

                        <div key={pergunta.id}>
                          <div className="card mb-2">
                            <a className="collapsed question-title-link" data-toggle="collapse"
                               href={`#collapse${pergunta.id}`}
                               aria-expanded="false"
                               aria-controls={`collapse${pergunta.id}`}>
                              <div className="card-header" role="tab" id={`heading${pergunta.id}`}>
                                <h5 className="mb-0">
                                  {pergunta.pergunta}
                                </h5>
                              </div>
                            </a>

                            <div id={`collapse${pergunta.id}`} className="collapse" role="tabpanel"
                                 aria-labelledby={`heading${pergunta.id}`}
                                 data-parent="#accordion">
                              <div className="card-body" dangerouslySetInnerHTML={ {__html: pergunta.resposta} }/>
                            </div>
                          </div>
                        </div>
                      )
                    })
                  }
                </div>


              </div>
            </div>
          </div>

        </section>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/views/PerguntasRespostas/Perguntas.js